import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=765ea186&scoped=true&"
import script from "./PartnerList.vue?vue&type=script&lang=js&"
export * from "./PartnerList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=765ea186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ea186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765ea186')) {
      api.createRecord('765ea186', component.options)
    } else {
      api.reload('765ea186', component.options)
    }
    module.hot.accept("./PartnerList.vue?vue&type=template&id=765ea186&scoped=true&", function () {
      api.rerender('765ea186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integrations/PartnerList.vue"
export default component.exports